import { MenuRoot, MenuTrigger, MenuContent, MenuItem } from '@/components/ui/menu';
import { IconButton } from '@chakra-ui/react';
import { ReactElement } from 'react';
import { EllipsisVertical } from 'lucide-react';

export interface Action {
    id: string;
    label: ReactElement | string;
    action: () => void;
    icon?: ReactElement;
    hidden?: boolean;
}

interface ActionMenuProps {
    actions: Action[] | (() => Action[]);
}

export function ActionMenu({ actions }: ActionMenuProps) {
    const hasActions = (typeof actions === 'function' ? actions() : actions).some((action) => !action.hidden);
    if (!hasActions) {
        return null;
    }
    return (
        <MenuRoot>
            <MenuTrigger asChild>
                <IconButton
                    h="20px"
                    minW="20px"
                    aria-label="Options"
                    border="none"
                    backgroundColor="none"
                    _hover={{ cursor: 'pointer' }}
                    _active={{ backgroundColor: 'transparent' }}
                    variant="outline">
                    <EllipsisVertical />
                </IconButton>
            </MenuTrigger>
            <MenuContent>
                {(typeof actions === 'function' ? actions() : actions).map(({ icon, action, label, id, hidden }) => (
                    <MenuItem key={id} value={id} fontSize="sm" onClick={action} display={hidden ? 'none' : undefined}>
                        {icon}
                        {label}
                    </MenuItem>
                ))}
            </MenuContent>
        </MenuRoot>
    );
}
